/**
 * Standard page header: title + subtitle + optional right-rail actions.
 * Every page uses this so spacing / typography is consistent.
 */

import React from 'react';
import { Box, Stack, Typography } from '@mui/material';

export default function PageHeader({ title, subtitle, actions, rightSlot }) {
  return (
    <Stack
      direction={{ xs: 'column', md: 'row' }}
      alignItems={{ md: 'flex-start' }}
      justifyContent="space-between"
      spacing={2}
      sx={{ mb: 3 }}
    >
      <Box>
        <Typography variant="h4" gutterBottom>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 720 }}>
            {subtitle}
          </Typography>
        )}
      </Box>

      {(rightSlot || actions) && (
        <Stack direction="row" spacing={1} alignItems="center">
          {rightSlot}
          {actions}
        </Stack>
      )}
    </Stack>
  );
}
